export default {

  handleFormValidation() {

    let oForm = $('#form-rol');

    let aRules = {
      name: {
        required: true
      },
      description: {
        required: false
      },
      slug: {
        required: true,
        slug: true
      },
      level: {
        required: true,
        number: true
      }
    };

    let aMessages = {
      name: {
        required: 'El campo Nombre es obligatorio.'
      },
      slug: {
        required: 'El campo Slug es obligatorio.',
        slug: 'El campo Slug tiene un formato inválido.'
      },
      level: {
        required: 'El campo Nivel es obligatorio.',
        number: 'El campo Nivel debe ser numérico.'
      }
    };

    $.validator.addMethod('slug', (value, element) => {
      return /^[a-z]+(\.[a-z]+)*$/.test(value);
    }, '');

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);

    $('#cmbPermisos').select2({
      placeholder: "Seleccionar permisos...",
      allowClear: true
    });
  },

  init() {
    this.handleFormValidation();
  },

  /**
   * Elimina un registro a través de un POST
   *
   * @param {Object} form Formulario que elimina el registro a través de la acción configurada
   * @param {String} nombre Nombre del registro a eliminar
   */
  eliminar(form, nombre) {
    let mensaje = '<p>¿Realmente deseas eliminar el Rol <strong>' + nombre + '</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>';
    FormHelper.confirm(form, mensaje);
  }
};
